export const ActionTypes = {
    CONFIRM_EDIT_SETTING: 'CONFIRM_EDIT_SETTING',
    SELECTED_SETTING: 'SELECTED_SETTING',

    CONFIRM_CREATE_RESTAURANT: 'CONFIRM_CREATE_RESTAURANT',
    CONFIRM_EDIT_RESTAURANT: 'CONFIRM_EDIT_RESTAURANT',
    CONFIRM_DELETE_RESTAURANT: 'CONFIRM_DELETE_RESTAURANT',
    LIST_RESTAURANT: 'LIST_RESTAURANT',
    SELECTED_RESTAURANT: 'SELECTED_RESTAURANT',
    RESTAURANT_STATUS_CHANGE: 'RESTAURANT_STATUS_CHANGE',

    CONFIRM_CREATE_BRANCH: 'CONFIRM_CREATE_BRANCH',
    CONFIRM_EDIT_BRANCH: 'CONFIRM_EDIT_BRANCH',
    CONFIRM_DELETE_BRANCH: 'CONFIRM_DELETE_BRANCH',
    LIST_BRANCH: 'LIST_BRANCH',
    SELECTED_BRANCH: 'SELECTED_BRANCH',
    BRANCH_STATUS_CHANGE: 'BRANCH_STATUS_CHANGE',
    

    CONFIRM_CREATE_CATEGORY: 'CONFIRM_CREATE_CATEGORY',
    CONFIRM_EDIT_CATEGORY: 'CONFIRM_EDIT_CATEGORY',
    CONFIRM_DELETE_CATEGORY: 'CONFIRM_DELETE_CATEGORY',
    LIST_CATEGORY: 'LIST_CATEGORY',
    SELECTED_CATEGORY: 'SELECTED_CATEGORY',
    SELECTED_CATEGORY_TYPE: 'SELECTED_CATEGORY_TYPE',
    CATEGORY_STATUS_CHANGE: 'CATEGORY_STATUS_CHANGE',

    CONFIRM_CREATE_CUISINE: 'CONFIRM_CREATE_CUISINE',
    CONFIRM_EDIT_CUISINE: 'CONFIRM_EDIT_CUISINE',
    CONFIRM_DELETE_CUISINE: 'CONFIRM_DELETE_CUISINE',
    LIST_CUISINE: 'LIST_CUISINE',
    SELECTED_CUISINE: 'SELECTED_CUISINE',
    CUISINE_STATUS_CHANGE: 'CUISINE_STATUS_CHANGE',

    CONFIRM_CREATE_INGREDIENT: 'CONFIRM_CREATE_INGREDIENT',
    CONFIRM_EDIT_INGREDIENT: 'CONFIRM_EDIT_INGREDIENT',
    CONFIRM_DELETE_INGREDIENT: 'CONFIRM_DELETE_INGREDIENT',
    LIST_INGREDIENT: 'LIST_INGREDIENT',
    SELECTED_INGREDIENT: 'SELECTED_INGREDIENT',
    INGREDIENT_STATUS_CHANGE: 'INGREDIENT_STATUS_CHANGE',

    CONFIRM_CREATE_ITEM: 'CONFIRM_CREATE_ITEM',
    CONFIRM_EDIT_ITEM: 'CONFIRM_EDIT_ITEM',
    CONFIRM_DELETE_ITEM: 'CONFIRM_DELETE_ITEM',
    LIST_ITEM: 'LIST_ITEM',
    SELECTED_ITEM: 'SELECTED_ITEM',
    ITEM_STATUS_CHANGE: 'ITEM_STATUS_CHANGE',
    ITEM_APPROVESTATUS_CHANGE: 'ITEM_APPROVESTATUS_CHANGE',
    ITEM_RECOMMENDED_CHANGE: 'ITEM_RECOMMENDED_CHANGE',

    LIST_BUSINESS_CATEGORY: 'LIST_BUSINESS_CATEGORY',


    LIST_ALL_ORDER: 'LIST_ALL_ORDER',
    LIST_ACCEPTED_ORDER: 'LIST_ACCEPTED_ORDER',
    LIST_PREPARED_ORDER: 'LIST_PREPARED_ORDER',
    LIST_DELIVERED_ORDER: 'LIST_DELIVERED_ORDER',
    LIST_REJECTED_ORDER: 'LIST_REJECTED_ORDER',
    SELECTED_ORDER: 'SELECTED_ORDER',
    ORDER_STATUS_CHANGE: 'ORDER_STATUS_CHANGE',


    LIST_INVOICE: 'LIST_INVOICE',
    INVOICE_ORDER: 'INVOICE_ORDER',
    INVOICE_ORDER_SUMMERY:'INVOICE_ORDER_SUMMERY'

}